import React from 'react'
import { Box, Typography } from '@mui/material'
import EmailOutlined from '@mui/icons-material/EmailOutlined'

const LABELS = {
  DESCONOCIDA: 'Entrega sin confirmar', ACEPTADA: 'Aceptado para envío',
  ENTREGADA: 'Entregado al servidor de correo', RETRASADA: 'Entrega pendiente',
  FALLIDA: 'Envío fallido según proveedor', REBOTADA: 'Correo rebotado',
  SUPRIMIDA: 'Envío suprimido', QUEJA: 'Queja de correo registrada',
}
const ATTEMPTS = {
  PENDIENTE: 'Intento pendiente', REINTENTABLE: 'Reintento programado',
  AGOTADO: 'Reintentos agotados', PAUSADO: 'Intento pausado', OMITIDO: 'Intento omitido',
}

/** Provider confirmation and local attempts are independent; legacy is unknown. */
export default function EmailDeliveryStatus({ correo }) {
  const confirmation = Object.hasOwn(LABELS, correo?.confirmacion) ? correo.confirmacion : 'DESCONOCIDA'
  const attempt = Object.hasOwn(ATTEMPTS, correo?.intento) ? ATTEMPTS[correo.intento] : null
  return (
    <Box component="span" role="group" aria-label="Estado del correo" sx={{ display: 'inline-flex', flexDirection: 'column', gap: 0.25, color: 'text.secondary' }}>
      <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5 }}>
        <EmailOutlined aria-hidden="true" sx={{ fontSize: 14 }} />
        <Typography component="span" variant="caption">{LABELS[confirmation]}</Typography>
      </Box>
      {confirmation === 'ENTREGADA' && <Typography component="span" variant="caption">No confirma lectura ni bandeja principal</Typography>}
      {attempt && <Typography component="span" variant="caption">{attempt}</Typography>}
    </Box>
  )
}
